export interface ThemeClasses {
  bg: string;
  border: string;
  text: string;
  textSecondary: string;
  cardBg: string;
  cardBorder: string;
  buttonHover: string;
  buttonText: string;
  buttonTextHover: string;
}

export interface AlertState {
  show: boolean;
  title: string;
  message: string;
  type: "success" | "error" | "warning" | "info";
}

export const ADAPTER_OPTIONS = [
  { value: "wialon", labelKey: "options.adapter.wialon" },
  { value: "mapon", labelKey: "options.adapter.mapon" },
] as const;

export const AUTH_STRATEGY_OPTIONS = [
  { value: "token-session", labelKey: "options.authStrategy.token-session" },
  { value: "query-key", labelKey: "options.authStrategy.query-key" },
] as const;
